import Vue from "vue"
import App from "./App.vue"
import router from "./router"
import { createProvider } from "./vue-apollo"
import store from "./store"

import VueGtag from "vue-gtag"
Vue.use(VueGtag, { config: { id: "G-YNVE9KJ727" } })

Vue.config.productionTip = false

import BootstrapVue from "bootstrap-vue"
import "bootstrap/dist/css/bootstrap.css"
import "bootstrap-vue/dist/bootstrap-vue.css"
Vue.use(BootstrapVue)

import VueRellax from "vue-rellax"
Vue.use(VueRellax)


import VueLazyLoad from 'vue-lazyload'
Vue.use(VueLazyLoad)
require('vue-image-lightbox/dist/vue-image-lightbox.min.css')

import VueSlickCarousel from "vue-slick-carousel"
import "vue-slick-carousel/dist/vue-slick-carousel.css"
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css"
Vue.component("VueSlickCarousel", VueSlickCarousel)

import "./components/forms/vueformulate"

import VueToast from "vue-toast-notification"
import "vue-toast-notification/dist/theme-default.css"
Vue.use(VueToast, {
	position: "top-right"
})

import * as VueGoogleMaps from 'vue2-google-maps'
Vue.use(VueGoogleMaps, {
	load: {
		key: 'AIzaSyBzEEtLs9L7OSGsw-wecbWOmJUcVZy_7l8',
	},
})


import Parallax from "vue-parallaxy"
Vue.component("parallax", Parallax)

import VueVideoPlayer from "vue-video-player"
import "video.js/dist/video-js.css"
Vue.use(VueVideoPlayer)

import VueYoutube from "vue-youtube"
Vue.use(VueYoutube)

import vClickOutside from "v-click-outside"
Vue.use(vClickOutside)

import VueMeta from "vue-meta"
Vue.use(VueMeta)

import Skeleton from "vue-loading-skeleton"
Vue.use(Skeleton)

import '../node_modules/vue-ads-pagination/dist/vue-ads-pagination.css'
import VueAdsPagination, { VueAdsPageButton } from 'vue-ads-pagination'
Vue.component('VueAdsPagination', VueAdsPagination)
Vue.component('VueAdsPageButton', VueAdsPageButton)

let moment = require("moment-timezone")
require("moment/locale/es")
Vue.use(require("vue-moment"), { moment })

import "@/assets/forms.scss"
import "@/assets/forms.css"
import "@/assets/style.css"

import Sticky from "vue-sticky-directive"
Vue.use(Sticky)

new Vue({
	router,
	store,
	apolloProvider: createProvider(),
	render: (h) => h(App)
}).$mount("#app")
